import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import CountdownModule from "./CountdownModule";
import HomeSectionLayout from "./HomeSectionLayout";
import StepCard from "./StepCard";
const StepSection = (param)=>{
    let { title , header , useTimer =false , countdownText , countdownTargetDate , steps , entityId , homeId  } = param;
    return /*#__PURE__*/ _jsxs(HomeSectionLayout, {
        header: header,
        title: title,
        isUseButton: false,
        children: [
            useTimer && /*#__PURE__*/ _jsx("div", {
                className: "w-full max-lg:px-8 max-sm:px-5",
                children: /*#__PURE__*/ _jsx(CountdownModule, {
                    text: countdownText,
                    targetDate: countdownTargetDate
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "scrollbar-hide flex w-full items-center gap-5 overflow-x-auto max-lg:px-8 max-sm:gap-3 max-sm:px-5",
                children: steps.map((stepData)=>/*#__PURE__*/ _jsx(StepCard, {
                        step: stepData.itemType,
                        title: stepData.itemTitle,
                        body: stepData.itemBodyText,
                        buttonText: stepData.itemButtonLabel,
                        buttonUrl: stepData.itemButtonLink,
                        onButtonClick: ()=>{
                            // MX-389: 스텝 카드 버튼 클릭 트래킹
                            mixpanelEvent("[Home] Step Section Clicked", {
                                "Entity Id": entityId,
                                "Home Id": homeId,
                                "Section Title": title,
                                Type: stepData.itemType,
                                Title: stepData.itemTitle,
                                "Button Name": stepData.itemButtonLabel,
                                "Button URL": stepData.itemButtonLink
                            });
                        }
                    }, stepData.itemType))
            })
        ]
    });
};
export default StepSection;
